import { render } from "./SelectionSuggestion.vue?vue&type=template&id=4273ae76&scoped=true&ts=true"
import script from "./SelectionSuggestion.ts?vue&type=script&lang=ts&external"
export * from "./SelectionSuggestion.ts?vue&type=script&lang=ts&external"

import "./SelectionSuggestion.scss?vue&type=style&index=0&id=4273ae76&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4273ae76"]])

export default __exports__